import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

const defaultState = {
    values: {
        image: undefined,
        image_base64: undefined,
        use_main_logo: true
    },
    isValid: false
};

export function creatingConf(
    state: any = defaultState,
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.UPDATE_CREATING_CONF:
            const values =
                state && action.payload
                    ? { ...state.values, ...action.payload.values }
                    : action.payload
                    ? action.payload.values
                    : null;

            const isValid =
                state && action.payload ? action.payload.isValid : false;

            values.subsidiary =  typeof values.subsidiary === "object" ? values.subsidiary.id : values.subsidiary

            // the API expands the category, the endpoints take its id
            if (values.game_category !== undefined) {
                values.game_category_id = values.game_category
                    ? values.game_category.id
                    : null;
                delete values.game_category;
            }

            return {
                values,
                isValid: isValid
            };

        case GamesActionTypes.CREATE_CONF_SUCCESS:
        case GamesActionTypes.EDIT_CONF_SUCCESS:
        case GamesActionTypes.CREATE_CONF_RESET:
            return defaultState;

        default:
            return state;
    }
}
